import { BetterErrors } from "@better-errors/client"
import { isProduction } from "./env"

export const be = new BetterErrors("https://better-errors.com/c/a25428fd-b08d-41fa-b554-7b96d5706640", {
  isEnabled: isProduction,
})
